import { META_ADD } from 'src/react/components/meta/constants';
import State from 'src/react/components/meta/types/State';
import { Action } from 'src/react/components/meta/types/Action';

const reducer = (state: State = {
  title: null,
  h1: null,
}, action: Action) => {
  switch (action.type) {
    case META_ADD:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
